'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _nuiShell = require('@concur/nui-shell');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _configureStore = require('./configureStore');

var _configureStore2 = _interopRequireDefault(_configureStore);

var _routes = require('./routes');

var _routes2 = _interopRequireDefault(_routes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* global __DEVTOOLS__, window */
var store = (0, _configureStore2.default)(window.__INITIAL_STATE__); // eslint-disable-line no-underscore-dangle

var DevTools = function DevTools() {
  return null;
};
if (process.env.NODE_ENV !== 'production') {
  DevTools = require('./DevTools').default;
}

var Root = function Root() {
  return _react2.default.createElement(
    _nuiShell.NuiClient,
    { store: store, routes: _routes2.default },
    typeof __DEVTOOLS__ !== 'undefined' && __DEVTOOLS__ && _react2.default.createElement(DevTools, null)
  );
};

exports.default = Root;


//////////////////
// WEBPACK FOOTER
// ./lib/app/Root.js
// module id = 410
// module chunks = 0